/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RegisterImport } from './routes/register'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AccessDeniedImport } from './routes/access-denied'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as SetPasswordTokenImport } from './routes/set-password.$token'
import { Route as AuthStatisticsIndexImport } from './routes/_auth/statistics/index'
import { Route as AuthGameSessionsIndexImport } from './routes/_auth/game-sessions/index'
import { Route as AuthGameSessionIndexImport } from './routes/_auth/game-session/index'
import { Route as AuthFriendsIndexImport } from './routes/_auth/friends/index'
import { Route as AuthDashboardIndexImport } from './routes/_auth/dashboard/index'
import { Route as AuthFriendsClaimImport } from './routes/_auth/friends/claim'
import { Route as AuthFriendsAddImport } from './routes/_auth/friends/add'
import { Route as AuthGameSessionGameSessionIdIndexImport } from './routes/_auth/game-session/$gameSessionId/index'
import { Route as AuthDashboardUserSettingsIndexImport } from './routes/_auth/dashboard/user-settings/index'
import { Route as AuthGameSessionGameSessionIdWatchImport } from './routes/_auth/game-session/$gameSessionId/watch'
import { Route as AuthGameSessionGameSessionIdTiebreakWinImport } from './routes/_auth/game-session/$gameSessionId/tiebreak-win'
import { Route as AuthGameSessionGameSessionIdFinishImport } from './routes/_auth/game-session/$gameSessionId/finish'
import { Route as AuthDashboardUserSettingsDetailsImport } from './routes/_auth/dashboard/user-settings/details'
import { Route as AuthDashboardUserSettingsAvatarImport } from './routes/_auth/dashboard/user-settings/avatar'
import { Route as AuthGameSessionGameSessionIdGamesIndexImport } from './routes/_auth/game-session/$gameSessionId/games/index'
import { Route as AuthGameSessionGameSessionIdGamesGameIdRoundsIndexImport } from './routes/_auth/game-session/$gameSessionId/games/$gameId/rounds/index'
import { Route as AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteImport } from './routes/_auth/game-session/$gameSessionId/games/$gameId/rounds/delete'

// Create/Update Routes

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AccessDeniedRoute = AccessDeniedImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SetPasswordTokenRoute = SetPasswordTokenImport.update({
  id: '/set-password/$token',
  path: '/set-password/$token',
  getParentRoute: () => rootRoute,
} as any)

const AuthStatisticsIndexRoute = AuthStatisticsIndexImport.update({
  id: '/statistics/',
  path: '/statistics/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionsIndexRoute = AuthGameSessionsIndexImport.update({
  id: '/game-sessions/',
  path: '/game-sessions/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionIndexRoute = AuthGameSessionIndexImport.update({
  id: '/game-session/',
  path: '/game-session/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsIndexRoute = AuthFriendsIndexImport.update({
  id: '/friends/',
  path: '/friends/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDashboardIndexRoute = AuthDashboardIndexImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsClaimRoute = AuthFriendsClaimImport.update({
  id: '/friends/claim',
  path: '/friends/claim',
  getParentRoute: () => AuthRoute,
} as any)

const AuthFriendsAddRoute = AuthFriendsAddImport.update({
  id: '/friends/add',
  path: '/friends/add',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameSessionGameSessionIdIndexRoute =
  AuthGameSessionGameSessionIdIndexImport.update({
    id: '/game-session/$gameSessionId/',
    path: '/game-session/$gameSessionId/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDashboardUserSettingsIndexRoute =
  AuthDashboardUserSettingsIndexImport.update({
    id: '/dashboard/user-settings/',
    path: '/dashboard/user-settings/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdWatchRoute =
  AuthGameSessionGameSessionIdWatchImport.update({
    id: '/game-session/$gameSessionId/watch',
    path: '/game-session/$gameSessionId/watch',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdTiebreakWinRoute =
  AuthGameSessionGameSessionIdTiebreakWinImport.update({
    id: '/game-session/$gameSessionId/tiebreak-win',
    path: '/game-session/$gameSessionId/tiebreak-win',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdFinishRoute =
  AuthGameSessionGameSessionIdFinishImport.update({
    id: '/game-session/$gameSessionId/finish',
    path: '/game-session/$gameSessionId/finish',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDashboardUserSettingsDetailsRoute =
  AuthDashboardUserSettingsDetailsImport.update({
    id: '/dashboard/user-settings/details',
    path: '/dashboard/user-settings/details',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthDashboardUserSettingsAvatarRoute =
  AuthDashboardUserSettingsAvatarImport.update({
    id: '/dashboard/user-settings/avatar',
    path: '/dashboard/user-settings/avatar',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdGamesIndexRoute =
  AuthGameSessionGameSessionIdGamesIndexImport.update({
    id: '/game-session/$gameSessionId/games/',
    path: '/game-session/$gameSessionId/games/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdGamesGameIdRoundsIndexRoute =
  AuthGameSessionGameSessionIdGamesGameIdRoundsIndexImport.update({
    id: '/game-session/$gameSessionId/games/$gameId/rounds/',
    path: '/game-session/$gameSessionId/games/$gameId/rounds/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteRoute =
  AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteImport.update({
    id: '/game-session/$gameSessionId/games/$gameId/rounds/delete',
    path: '/game-session/$gameSessionId/games/$gameId/rounds/delete',
    getParentRoute: () => AuthRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/access-denied': {
      id: '/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AccessDeniedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/set-password/$token': {
      id: '/set-password/$token'
      path: '/set-password/$token'
      fullPath: '/set-password/$token'
      preLoaderRoute: typeof SetPasswordTokenImport
      parentRoute: typeof rootRoute
    }
    '/_auth/friends/add': {
      id: '/_auth/friends/add'
      path: '/friends/add'
      fullPath: '/friends/add'
      preLoaderRoute: typeof AuthFriendsAddImport
      parentRoute: typeof AuthImport
    }
    '/_auth/friends/claim': {
      id: '/_auth/friends/claim'
      path: '/friends/claim'
      fullPath: '/friends/claim'
      preLoaderRoute: typeof AuthFriendsClaimImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/': {
      id: '/_auth/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/friends/': {
      id: '/_auth/friends/'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof AuthFriendsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/': {
      id: '/_auth/game-session/'
      path: '/game-session'
      fullPath: '/game-session'
      preLoaderRoute: typeof AuthGameSessionIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-sessions/': {
      id: '/_auth/game-sessions/'
      path: '/game-sessions'
      fullPath: '/game-sessions'
      preLoaderRoute: typeof AuthGameSessionsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/statistics/': {
      id: '/_auth/statistics/'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AuthStatisticsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/avatar': {
      id: '/_auth/dashboard/user-settings/avatar'
      path: '/dashboard/user-settings/avatar'
      fullPath: '/dashboard/user-settings/avatar'
      preLoaderRoute: typeof AuthDashboardUserSettingsAvatarImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/details': {
      id: '/_auth/dashboard/user-settings/details'
      path: '/dashboard/user-settings/details'
      fullPath: '/dashboard/user-settings/details'
      preLoaderRoute: typeof AuthDashboardUserSettingsDetailsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/finish': {
      id: '/_auth/game-session/$gameSessionId/finish'
      path: '/game-session/$gameSessionId/finish'
      fullPath: '/game-session/$gameSessionId/finish'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdFinishImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/tiebreak-win': {
      id: '/_auth/game-session/$gameSessionId/tiebreak-win'
      path: '/game-session/$gameSessionId/tiebreak-win'
      fullPath: '/game-session/$gameSessionId/tiebreak-win'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdTiebreakWinImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/watch': {
      id: '/_auth/game-session/$gameSessionId/watch'
      path: '/game-session/$gameSessionId/watch'
      fullPath: '/game-session/$gameSessionId/watch'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdWatchImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard/user-settings/': {
      id: '/_auth/dashboard/user-settings/'
      path: '/dashboard/user-settings'
      fullPath: '/dashboard/user-settings'
      preLoaderRoute: typeof AuthDashboardUserSettingsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/': {
      id: '/_auth/game-session/$gameSessionId/'
      path: '/game-session/$gameSessionId'
      fullPath: '/game-session/$gameSessionId'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/games/': {
      id: '/_auth/game-session/$gameSessionId/games/'
      path: '/game-session/$gameSessionId/games'
      fullPath: '/game-session/$gameSessionId/games'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdGamesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/games/$gameId/rounds/delete': {
      id: '/_auth/game-session/$gameSessionId/games/$gameId/rounds/delete'
      path: '/game-session/$gameSessionId/games/$gameId/rounds/delete'
      fullPath: '/game-session/$gameSessionId/games/$gameId/rounds/delete'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteImport
      parentRoute: typeof AuthImport
    }
    '/_auth/game-session/$gameSessionId/games/$gameId/rounds/': {
      id: '/_auth/game-session/$gameSessionId/games/$gameId/rounds/'
      path: '/game-session/$gameSessionId/games/$gameId/rounds'
      fullPath: '/game-session/$gameSessionId/games/$gameId/rounds'
      preLoaderRoute: typeof AuthGameSessionGameSessionIdGamesGameIdRoundsIndexImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthFriendsAddRoute: typeof AuthFriendsAddRoute
  AuthFriendsClaimRoute: typeof AuthFriendsClaimRoute
  AuthDashboardIndexRoute: typeof AuthDashboardIndexRoute
  AuthFriendsIndexRoute: typeof AuthFriendsIndexRoute
  AuthGameSessionIndexRoute: typeof AuthGameSessionIndexRoute
  AuthGameSessionsIndexRoute: typeof AuthGameSessionsIndexRoute
  AuthStatisticsIndexRoute: typeof AuthStatisticsIndexRoute
  AuthDashboardUserSettingsAvatarRoute: typeof AuthDashboardUserSettingsAvatarRoute
  AuthDashboardUserSettingsDetailsRoute: typeof AuthDashboardUserSettingsDetailsRoute
  AuthGameSessionGameSessionIdFinishRoute: typeof AuthGameSessionGameSessionIdFinishRoute
  AuthGameSessionGameSessionIdTiebreakWinRoute: typeof AuthGameSessionGameSessionIdTiebreakWinRoute
  AuthGameSessionGameSessionIdWatchRoute: typeof AuthGameSessionGameSessionIdWatchRoute
  AuthDashboardUserSettingsIndexRoute: typeof AuthDashboardUserSettingsIndexRoute
  AuthGameSessionGameSessionIdIndexRoute: typeof AuthGameSessionGameSessionIdIndexRoute
  AuthGameSessionGameSessionIdGamesIndexRoute: typeof AuthGameSessionGameSessionIdGamesIndexRoute
  AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteRoute: typeof AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteRoute
  AuthGameSessionGameSessionIdGamesGameIdRoundsIndexRoute: typeof AuthGameSessionGameSessionIdGamesGameIdRoundsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthFriendsAddRoute: AuthFriendsAddRoute,
  AuthFriendsClaimRoute: AuthFriendsClaimRoute,
  AuthDashboardIndexRoute: AuthDashboardIndexRoute,
  AuthFriendsIndexRoute: AuthFriendsIndexRoute,
  AuthGameSessionIndexRoute: AuthGameSessionIndexRoute,
  AuthGameSessionsIndexRoute: AuthGameSessionsIndexRoute,
  AuthStatisticsIndexRoute: AuthStatisticsIndexRoute,
  AuthDashboardUserSettingsAvatarRoute: AuthDashboardUserSettingsAvatarRoute,
  AuthDashboardUserSettingsDetailsRoute: AuthDashboardUserSettingsDetailsRoute,
  AuthGameSessionGameSessionIdFinishRoute:
    AuthGameSessionGameSessionIdFinishRoute,
  AuthGameSessionGameSessionIdTiebreakWinRoute:
    AuthGameSessionGameSessionIdTiebreakWinRoute,
  AuthGameSessionGameSessionIdWatchRoute:
    AuthGameSessionGameSessionIdWatchRoute,
  AuthDashboardUserSettingsIndexRoute: AuthDashboardUserSettingsIndexRoute,
  AuthGameSessionGameSessionIdIndexRoute:
    AuthGameSessionGameSessionIdIndexRoute,
  AuthGameSessionGameSessionIdGamesIndexRoute:
    AuthGameSessionGameSessionIdGamesIndexRoute,
  AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteRoute:
    AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteRoute,
  AuthGameSessionGameSessionIdGamesGameIdRoundsIndexRoute:
    AuthGameSessionGameSessionIdGamesGameIdRoundsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/friends/add': typeof AuthFriendsAddRoute
  '/friends/claim': typeof AuthFriendsClaimRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/friends': typeof AuthFriendsIndexRoute
  '/game-session': typeof AuthGameSessionIndexRoute
  '/game-sessions': typeof AuthGameSessionsIndexRoute
  '/statistics': typeof AuthStatisticsIndexRoute
  '/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/game-session/$gameSessionId/finish': typeof AuthGameSessionGameSessionIdFinishRoute
  '/game-session/$gameSessionId/tiebreak-win': typeof AuthGameSessionGameSessionIdTiebreakWinRoute
  '/game-session/$gameSessionId/watch': typeof AuthGameSessionGameSessionIdWatchRoute
  '/dashboard/user-settings': typeof AuthDashboardUserSettingsIndexRoute
  '/game-session/$gameSessionId': typeof AuthGameSessionGameSessionIdIndexRoute
  '/game-session/$gameSessionId/games': typeof AuthGameSessionGameSessionIdGamesIndexRoute
  '/game-session/$gameSessionId/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteRoute
  '/game-session/$gameSessionId/games/$gameId/rounds': typeof AuthGameSessionGameSessionIdGamesGameIdRoundsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/friends/add': typeof AuthFriendsAddRoute
  '/friends/claim': typeof AuthFriendsClaimRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/friends': typeof AuthFriendsIndexRoute
  '/game-session': typeof AuthGameSessionIndexRoute
  '/game-sessions': typeof AuthGameSessionsIndexRoute
  '/statistics': typeof AuthStatisticsIndexRoute
  '/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/game-session/$gameSessionId/finish': typeof AuthGameSessionGameSessionIdFinishRoute
  '/game-session/$gameSessionId/tiebreak-win': typeof AuthGameSessionGameSessionIdTiebreakWinRoute
  '/game-session/$gameSessionId/watch': typeof AuthGameSessionGameSessionIdWatchRoute
  '/dashboard/user-settings': typeof AuthDashboardUserSettingsIndexRoute
  '/game-session/$gameSessionId': typeof AuthGameSessionGameSessionIdIndexRoute
  '/game-session/$gameSessionId/games': typeof AuthGameSessionGameSessionIdGamesIndexRoute
  '/game-session/$gameSessionId/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteRoute
  '/game-session/$gameSessionId/games/$gameId/rounds': typeof AuthGameSessionGameSessionIdGamesGameIdRoundsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/access-denied': typeof AccessDeniedRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password/$token': typeof SetPasswordTokenRoute
  '/_auth/friends/add': typeof AuthFriendsAddRoute
  '/_auth/friends/claim': typeof AuthFriendsClaimRoute
  '/_auth/dashboard/': typeof AuthDashboardIndexRoute
  '/_auth/friends/': typeof AuthFriendsIndexRoute
  '/_auth/game-session/': typeof AuthGameSessionIndexRoute
  '/_auth/game-sessions/': typeof AuthGameSessionsIndexRoute
  '/_auth/statistics/': typeof AuthStatisticsIndexRoute
  '/_auth/dashboard/user-settings/avatar': typeof AuthDashboardUserSettingsAvatarRoute
  '/_auth/dashboard/user-settings/details': typeof AuthDashboardUserSettingsDetailsRoute
  '/_auth/game-session/$gameSessionId/finish': typeof AuthGameSessionGameSessionIdFinishRoute
  '/_auth/game-session/$gameSessionId/tiebreak-win': typeof AuthGameSessionGameSessionIdTiebreakWinRoute
  '/_auth/game-session/$gameSessionId/watch': typeof AuthGameSessionGameSessionIdWatchRoute
  '/_auth/dashboard/user-settings/': typeof AuthDashboardUserSettingsIndexRoute
  '/_auth/game-session/$gameSessionId/': typeof AuthGameSessionGameSessionIdIndexRoute
  '/_auth/game-session/$gameSessionId/games/': typeof AuthGameSessionGameSessionIdGamesIndexRoute
  '/_auth/game-session/$gameSessionId/games/$gameId/rounds/delete': typeof AuthGameSessionGameSessionIdGamesGameIdRoundsDeleteRoute
  '/_auth/game-session/$gameSessionId/games/$gameId/rounds/': typeof AuthGameSessionGameSessionIdGamesGameIdRoundsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/set-password/$token'
    | '/friends/add'
    | '/friends/claim'
    | '/dashboard'
    | '/friends'
    | '/game-session'
    | '/game-sessions'
    | '/statistics'
    | '/dashboard/user-settings/avatar'
    | '/dashboard/user-settings/details'
    | '/game-session/$gameSessionId/finish'
    | '/game-session/$gameSessionId/tiebreak-win'
    | '/game-session/$gameSessionId/watch'
    | '/dashboard/user-settings'
    | '/game-session/$gameSessionId'
    | '/game-session/$gameSessionId/games'
    | '/game-session/$gameSessionId/games/$gameId/rounds/delete'
    | '/game-session/$gameSessionId/games/$gameId/rounds'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/set-password/$token'
    | '/friends/add'
    | '/friends/claim'
    | '/dashboard'
    | '/friends'
    | '/game-session'
    | '/game-sessions'
    | '/statistics'
    | '/dashboard/user-settings/avatar'
    | '/dashboard/user-settings/details'
    | '/game-session/$gameSessionId/finish'
    | '/game-session/$gameSessionId/tiebreak-win'
    | '/game-session/$gameSessionId/watch'
    | '/dashboard/user-settings'
    | '/game-session/$gameSessionId'
    | '/game-session/$gameSessionId/games'
    | '/game-session/$gameSessionId/games/$gameId/rounds/delete'
    | '/game-session/$gameSessionId/games/$gameId/rounds'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/access-denied'
    | '/login'
    | '/logout'
    | '/register'
    | '/reset-password'
    | '/set-password/$token'
    | '/_auth/friends/add'
    | '/_auth/friends/claim'
    | '/_auth/dashboard/'
    | '/_auth/friends/'
    | '/_auth/game-session/'
    | '/_auth/game-sessions/'
    | '/_auth/statistics/'
    | '/_auth/dashboard/user-settings/avatar'
    | '/_auth/dashboard/user-settings/details'
    | '/_auth/game-session/$gameSessionId/finish'
    | '/_auth/game-session/$gameSessionId/tiebreak-win'
    | '/_auth/game-session/$gameSessionId/watch'
    | '/_auth/dashboard/user-settings/'
    | '/_auth/game-session/$gameSessionId/'
    | '/_auth/game-session/$gameSessionId/games/'
    | '/_auth/game-session/$gameSessionId/games/$gameId/rounds/delete'
    | '/_auth/game-session/$gameSessionId/games/$gameId/rounds/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AccessDeniedRoute: typeof AccessDeniedRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordTokenRoute: typeof SetPasswordTokenRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AccessDeniedRoute: AccessDeniedRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordTokenRoute: SetPasswordTokenRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/access-denied",
        "/login",
        "/logout",
        "/register",
        "/reset-password",
        "/set-password/$token"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/friends/add",
        "/_auth/friends/claim",
        "/_auth/dashboard/",
        "/_auth/friends/",
        "/_auth/game-session/",
        "/_auth/game-sessions/",
        "/_auth/statistics/",
        "/_auth/dashboard/user-settings/avatar",
        "/_auth/dashboard/user-settings/details",
        "/_auth/game-session/$gameSessionId/finish",
        "/_auth/game-session/$gameSessionId/tiebreak-win",
        "/_auth/game-session/$gameSessionId/watch",
        "/_auth/dashboard/user-settings/",
        "/_auth/game-session/$gameSessionId/",
        "/_auth/game-session/$gameSessionId/games/",
        "/_auth/game-session/$gameSessionId/games/$gameId/rounds/delete",
        "/_auth/game-session/$gameSessionId/games/$gameId/rounds/"
      ]
    },
    "/access-denied": {
      "filePath": "access-denied.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/register": {
      "filePath": "register.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/set-password/$token": {
      "filePath": "set-password.$token.tsx"
    },
    "/_auth/friends/add": {
      "filePath": "_auth/friends/add.tsx",
      "parent": "/_auth"
    },
    "/_auth/friends/claim": {
      "filePath": "_auth/friends/claim.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/": {
      "filePath": "_auth/dashboard/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/friends/": {
      "filePath": "_auth/friends/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/": {
      "filePath": "_auth/game-session/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-sessions/": {
      "filePath": "_auth/game-sessions/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/statistics/": {
      "filePath": "_auth/statistics/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/avatar": {
      "filePath": "_auth/dashboard/user-settings/avatar.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/details": {
      "filePath": "_auth/dashboard/user-settings/details.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/finish": {
      "filePath": "_auth/game-session/$gameSessionId/finish.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/tiebreak-win": {
      "filePath": "_auth/game-session/$gameSessionId/tiebreak-win.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/watch": {
      "filePath": "_auth/game-session/$gameSessionId/watch.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard/user-settings/": {
      "filePath": "_auth/dashboard/user-settings/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/": {
      "filePath": "_auth/game-session/$gameSessionId/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/games/": {
      "filePath": "_auth/game-session/$gameSessionId/games/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/games/$gameId/rounds/delete": {
      "filePath": "_auth/game-session/$gameSessionId/games/$gameId/rounds/delete.tsx",
      "parent": "/_auth"
    },
    "/_auth/game-session/$gameSessionId/games/$gameId/rounds/": {
      "filePath": "_auth/game-session/$gameSessionId/games/$gameId/rounds/index.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
